// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nb-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(3, 2, 1, 0.62);
  pointer-events: none;
  font-family: "Din-pro", Georgia, serif;
}

.nb-frame {
  pointer-events: auto;
  width: clamp(560px, 62vw, 960px);
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  padding: 14px;
  border-radius: 4px;
  background: linear-gradient(135deg, #6b4a2e 0%, #4a3220 45%, #2b1d12 100%);
  border: 2px solid #2b1d12;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.7), inset 0 0 0 2px rgba(255, 255, 255, 0.06);
  color: #dccca4;
}

.nb-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 4px 6px 12px;
}

.nb-title {
  flex: 1 1 auto;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 26px;
  letter-spacing: 0.04em;
  color: #c9a24f;
  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.5);
}

.nb-tabs {
  display: flex;
  gap: 6px;
}

.nb-tab,
.nb-close {
  font: inherit;
  font-size: 14px;
  padding: 7px 14px;
  border-radius: 3px;
  border: 1px solid #2b1d12;
  background: #4a3220;
  color: #dccca4;
  cursor: pointer;
}
.nb-tab:hover,
.nb-close:hover {
  background: #6b4a2e;
}
.nb-tab:focus-visible,
.nb-close:focus-visible {
  outline: 2px solid #c9a24f;
  outline-offset: 2px;
}

.nb-tab--on {
  background: #dccca4;
  color: #2a1f14;
  border-color: #bfa97a;
}

.nb-board,
.nb-notes {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  border-radius: 3px;
  border: 2px solid #2b1d12;
  background: repeating-linear-gradient(90deg, rgba(0, 0, 0, 0.16) 0 2px, transparent 2px 120px), linear-gradient(180deg, #5a3f27, #4b3420);
  box-shadow: inset 0 4px 14px rgba(0, 0, 0, 0.6);
  padding: 22px 20px;
}

.nb-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 26px 20px;
}

.nb-paper {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 2px;
  background: linear-gradient(180deg, #e3d4ad, #dccca4);
  border: 1px solid #bfa97a;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.55);
  color: #2a1f14;
  transition: transform 0.15s ease;
}
.nb-paper--open {
  z-index: 2;
  grid-column: span 2;
}
.nb-paper--list {
  margin-bottom: 18px;
}

.nb-pin {
  position: absolute;
  top: -8px;
  left: 50%;
  width: 14px;
  height: 14px;
  margin-left: -7px;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 35%, #8b8b92, #3b3b3f);
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.6);
}

.nb-paper-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
  padding: 16px 14px 8px;
  font: inherit;
  color: inherit;
  background: none;
  border: 0;
  cursor: pointer;
}
.nb-paper-body:focus-visible {
  outline: 2px solid #c9a24f;
  outline-offset: -2px;
}

.nb-paper-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 17px;
  line-height: 1.2;
}

.nb-paper-text {
  font-family: Georgia, serif;
  font-size: 14px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
}
.nb-paper-text--clamp {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.nb-paper-meta {
  font-size: 12px;
  color: #5b4a35;
}

.nb-paper-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px 10px 10px;
}

.nb-btn {
  font: inherit;
  font-size: 13px;
  padding: 5px 10px;
  border-radius: 3px;
  border: 1px solid #5b4a35;
  background: rgba(255, 255, 255, 0.35);
  color: #2a1f14;
  cursor: pointer;
}
.nb-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.7);
}
.nb-btn:focus-visible {
  outline: 2px solid #4a3220;
  outline-offset: 2px;
}
.nb-btn:disabled {
  opacity: 0.45;
  cursor: default;
}
.nb-btn--main {
  background: #4a3220;
  border-color: #2b1d12;
  color: #dccca4;
}
.nb-btn--main:hover:not(:disabled) {
  background: #6b4a2e;
}
.nb-btn--quiet {
  border-style: dashed;
}

.nb-notes {
  display: grid;
  grid-template-columns: minmax(240px, 300px) 1fr;
  gap: 24px;
  align-items: start;
}

.nb-editor {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  border-radius: 2px;
  background: linear-gradient(180deg, #e3d4ad, #dccca4);
  border: 1px solid #bfa97a;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.55);
  color: #2a1f14;
}

.nb-editor-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 18px;
}

.nb-input,
.nb-textarea {
  font: inherit;
  font-family: Georgia, serif;
  font-size: 14px;
  padding: 7px 9px;
  border-radius: 2px;
  border: 1px solid #5b4a35;
  background: rgba(255, 255, 255, 0.55);
  color: #2a1f14;
}
.nb-input:focus,
.nb-textarea:focus {
  outline: 2px solid #4a3220;
}

.nb-textarea {
  min-height: 150px;
  resize: vertical;
}

.nb-editor-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nb-count {
  font-size: 12px;
  color: #5b4a35;
}

.nb-give {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 0 10px 10px;
}

.nb-give-none {
  font-size: 13px;
  color: #5b4a35;
}

.nb-empty {
  padding: 30px 12px;
  text-align: center;
  color: #dccca4;
  font-family: Georgia, serif;
  font-size: 15px;
}

.nb-foot {
  flex: 0 0 auto;
  padding: 10px 6px 0;
  font-size: 12px;
  color: rgba(220, 204, 164, 0.7);
}
.nb-foot kbd {
  padding: 1px 6px;
  border: 1px solid rgba(220, 204, 164, 0.5);
  border-radius: 3px;
}

@media (prefers-reduced-motion: reduce) {
  .nb-paper {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/noticeBoard/styles.scss"],"names":[],"mappings":"AAcA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,oBAAA;EACA,sCAAA;AAbF;;AAgBA;EACE,oBAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,0EAAA;EACA,yBAAA;EACA,qFAAA;EACA,cA9BM;AAiBR;;AAgBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;AAbF;;AAgBA;EACE,cAAA;EACA,kDAAA;EACA,eAAA;EACA,sBAAA;EACA,cAzCK;EA0CL,uCAAA;AAbF;;AAgBA;EACE,aAAA;EACA,QAAA;AAbF;;AAgBA;;EAEE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAjEK;EAkEL,cA/DM;EAgEN,eAAA;AAbF;AAeE;;EACE,mBArES;AAyDb;AAeE;;EACE,0BAAA;EACA,mBAAA;AAZJ;;AAgBA;EACE,mBA7EM;EA8EN,cA5EI;EA6EJ,qBA9EW;AAiEb;;AAgBA;;EAEE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yIACE;EAEF,+CAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,4DAAA;EACA,cAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,qDAAA;EACA,yBAAA;EACA,0CAAA;EACA,cA5GI;EA6GJ,gCAAA;AAfF;AAiBE;EACE,UAAA;EACA,mBAAA;AAfJ;AAkBE;EACE,mBAAA;AAhBJ;;AAoBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gEAAA;EACA,wCAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;AAjBF;AAmBE;EACE,0BAAA;EACA,oBAAA;AAjBJ;;AAqBA;EACE,kDAAA;EACA,eAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AAlBF;AAoBE;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAlBJ;;AAsBA;EACE,eAAA;EACA,cA7KS;AA0JX;;AAsBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qCAAA;EACA,cA/LI;EAgMJ,eAAA;AAnBF;AAqBE;EACE,oCAAA;AAnBJ;AAsBE;EACE,0BAAA;EACA,mBAAA;AApBJ;AAuBE;EACE,aAAA;EACA,eAAA;AArBJ;AAwBE;EACE,mBAtNG;EAuNH,qBAxNQ;EAyNR,cArNI;AA+LR;AAwBI;EACE,mBA1NO;AAoMb;AA0BE;EACE,oBAAA;AAxBJ;;AA4BA;EACE,aAAA;EACA,+CAAA;EACA,SAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,qDAAA;EACA,yBAAA;EACA,0CAAA;EACA,cA/OI;AAsNN;;AA4BA;EACE,kDAAA;EACA,eAAA;AAzBF;;AA4BA;;EAEE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qCAAA;EACA,cAhQI;AAuON;AA2BE;;EACE,0BAAA;AAxBJ;;AA4BA;EACE,iBAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,cAnRS;AA0PX;;AA4BA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,cAhSS;AAuQX;;AA4BA;EACE,kBAAA;EACA,kBAAA;EACA,cAzSM;EA0SN,2BAAA;EACA,eAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;AAzBF;AA2BE;EACE,gBAAA;EACA,0CAAA;EACA,kBAAA;AAzBJ;;AA6BA;EACE;IACE,gBAAA;EA1BF;AACF","sourcesContent":["// Notice board: an old wooden board with paper notes pinned on it. Its own look (wood and parchment), not the ink\n// panel of the menus: the board is an object of the world, opened with E.\n\n$wood-dark: #2b1d12;\n$wood: #4a3220;\n$wood-light: #6b4a2e;\n$board: #5a3f27;\n$paper: #dccca4;\n$paper-edge: #bfa97a;\n$ink: #2a1f14;\n$ink-soft: #5b4a35;\n$iron: #3b3b3f;\n$gold: #c9a24f;\n\n.nb-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(3, 2, 1, 0.62);\n  pointer-events: none;\n  font-family: 'Din-pro', Georgia, serif;\n}\n\n.nb-frame {\n  pointer-events: auto;\n  width: clamp(560px, 62vw, 960px);\n  max-height: 86vh;\n  display: flex;\n  flex-direction: column;\n  padding: 14px;\n  border-radius: 4px;\n  background: linear-gradient(135deg, $wood-light 0%, $wood 45%, $wood-dark 100%);\n  border: 2px solid $wood-dark;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.7), inset 0 0 0 2px rgba(255, 255, 255, 0.06);\n  color: $paper;\n}\n\n.nb-header {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 4px 6px 12px;\n}\n\n.nb-title {\n  flex: 1 1 auto;\n  font-family: 'Marcellus', 'Cinzel', Georgia, serif;\n  font-size: 26px;\n  letter-spacing: 0.04em;\n  color: $gold;\n  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.5);\n}\n\n.nb-tabs {\n  display: flex;\n  gap: 6px;\n}\n\n.nb-tab,\n.nb-close {\n  font: inherit;\n  font-size: 14px;\n  padding: 7px 14px;\n  border-radius: 3px;\n  border: 1px solid $wood-dark;\n  background: $wood;\n  color: $paper;\n  cursor: pointer;\n\n  &:hover {\n    background: $wood-light;\n  }\n\n  &:focus-visible {\n    outline: 2px solid $gold;\n    outline-offset: 2px;\n  }\n}\n\n.nb-tab--on {\n  background: $paper;\n  color: $ink;\n  border-color: $paper-edge;\n}\n\n.nb-board,\n.nb-notes {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  border-radius: 3px;\n  border: 2px solid $wood-dark;\n  background:\n    repeating-linear-gradient(90deg, rgba(0, 0, 0, 0.16) 0 2px, transparent 2px 120px),\n    linear-gradient(180deg, $board, #4b3420);\n  box-shadow: inset 0 4px 14px rgba(0, 0, 0, 0.6);\n  padding: 22px 20px;\n}\n\n.nb-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n  gap: 26px 20px;\n}\n\n.nb-paper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border-radius: 2px;\n  background: linear-gradient(180deg, #e3d4ad, $paper);\n  border: 1px solid $paper-edge;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.55);\n  color: $ink;\n  transition: transform 0.15s ease;\n\n  &--open {\n    z-index: 2;\n    grid-column: span 2;\n  }\n\n  &--list {\n    margin-bottom: 18px;\n  }\n}\n\n.nb-pin {\n  position: absolute;\n  top: -8px;\n  left: 50%;\n  width: 14px;\n  height: 14px;\n  margin-left: -7px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 35% 35%, #8b8b92, $iron);\n  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.6);\n}\n\n.nb-paper-body {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  text-align: left;\n  padding: 16px 14px 8px;\n  font: inherit;\n  color: inherit;\n  background: none;\n  border: 0;\n  cursor: pointer;\n\n  &:focus-visible {\n    outline: 2px solid $gold;\n    outline-offset: -2px;\n  }\n}\n\n.nb-paper-title {\n  font-family: 'Marcellus', 'Cinzel', Georgia, serif;\n  font-size: 17px;\n  line-height: 1.2;\n}\n\n.nb-paper-text {\n  font-family: Georgia, serif;\n  font-size: 14px;\n  line-height: 1.4;\n  white-space: pre-wrap;\n  word-break: break-word;\n\n  &--clamp {\n    display: -webkit-box;\n    -webkit-line-clamp: 5;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n}\n\n.nb-paper-meta {\n  font-size: 12px;\n  color: $ink-soft;\n}\n\n.nb-paper-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 6px 10px 10px;\n}\n\n.nb-btn {\n  font: inherit;\n  font-size: 13px;\n  padding: 5px 10px;\n  border-radius: 3px;\n  border: 1px solid $ink-soft;\n  background: rgba(255, 255, 255, 0.35);\n  color: $ink;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.7);\n  }\n\n  &:focus-visible {\n    outline: 2px solid $wood;\n    outline-offset: 2px;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: default;\n  }\n\n  &--main {\n    background: $wood;\n    border-color: $wood-dark;\n    color: $paper;\n\n    &:hover:not(:disabled) {\n      background: $wood-light;\n    }\n  }\n\n  &--quiet {\n    border-style: dashed;\n  }\n}\n\n.nb-notes {\n  display: grid;\n  grid-template-columns: minmax(240px, 300px) 1fr;\n  gap: 24px;\n  align-items: start;\n}\n\n.nb-editor {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 14px;\n  border-radius: 2px;\n  background: linear-gradient(180deg, #e3d4ad, $paper);\n  border: 1px solid $paper-edge;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.55);\n  color: $ink;\n}\n\n.nb-editor-title {\n  font-family: 'Marcellus', 'Cinzel', Georgia, serif;\n  font-size: 18px;\n}\n\n.nb-input,\n.nb-textarea {\n  font: inherit;\n  font-family: Georgia, serif;\n  font-size: 14px;\n  padding: 7px 9px;\n  border-radius: 2px;\n  border: 1px solid $ink-soft;\n  background: rgba(255, 255, 255, 0.55);\n  color: $ink;\n\n  &:focus {\n    outline: 2px solid $wood;\n  }\n}\n\n.nb-textarea {\n  min-height: 150px;\n  resize: vertical;\n}\n\n.nb-editor-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.nb-count {\n  font-size: 12px;\n  color: $ink-soft;\n}\n\n.nb-give {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 0 10px 10px;\n}\n\n.nb-give-none {\n  font-size: 13px;\n  color: $ink-soft;\n}\n\n.nb-empty {\n  padding: 30px 12px;\n  text-align: center;\n  color: $paper;\n  font-family: Georgia, serif;\n  font-size: 15px;\n}\n\n.nb-foot {\n  flex: 0 0 auto;\n  padding: 10px 6px 0;\n  font-size: 12px;\n  color: rgba(220, 204, 164, 0.7);\n\n  kbd {\n    padding: 1px 6px;\n    border: 1px solid rgba(220, 204, 164, 0.5);\n    border-radius: 3px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .nb-paper {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
